<jni-add-contact-information
  [(display)]="displayAddContact"
  *ngIf="displayAddContact"
  [vendorObject]="vendorObject"
  [headingStatus]="contactheadingStatus"
  [vendorIdFromModal]="vendorStatusId"
  (refreshSummary)="refreshSummary()"
  [isFromVendorSummary]="true"
  [loggedInUserIsAdmin]="loggedInUserIsAdmin">
</jni-add-contact-information>

<jni-add-address-information
  [(display)]="displayAddAddress"
  *ngIf="displayAddAddress"
  [addressObject]="addressObject"
  [headingStatus]="addressHeadingStatus"
  [vendorIdFromModal]="vendorStatusId"
  [isPrimaryFieldStatus]="false"
  (refreshSummary)="refreshSummary()"
  [isFromVendorSummary]="true"
  [loggedInUserIsAdmin]="loggedInUserIsAdmin">
</jni-add-address-information>

<jni-view-contact-information
  [(display)]="displayViewContact"
  *ngIf="displayViewContact"
  [vendorIdFromModal]="vendorStatusId"
  (editEvent)="onOpenEditContact($event)">
</jni-view-contact-information>

<jni-view-address-information
  [(display)]="displayViewAddress"
  *ngIf="displayViewAddress"
  [vendorIdFromModal]="vendorStatusId"
  (editEvent)="openEditAddress($event)">
</jni-view-address-information>

<!-- <div class="row stacker-body">
  <div
    class="d-flex justify-content-between align-items-center globalborder-btm-header mb-3 pb-2">
    <span class="d-flex gap-2 align-items-center">
      <h2 class="mb-0">User Account</h2>
      Vendor # {{ vendorStatusId }} -
      {{ vendorBasicInformation?.vendorOrganizationNameD365 }}
    </span>
  </div>
</div> -->

<!-- Diff -->
<!-- 
<div class="vendorDetails py-1">
  <header class="d-flex align-items-center justify-content-between mb-4">
    <div class="align-items-center d-flex position-rel">
      <h2 class="me-auto me-3">
        Vendor Summary

        <a
          >Vendor # {{ vendorStatusId }} -
          {{ vendorBasicInformation?.vendorOrganizationNameD365 }}
        </a>
      </h2>

      <div
        class="d-flex align-items-center justify-content-between px-3 pe-5 py-2 position-relative">
        <h2 class="mb-0">
          <strong class="me-1">N:</strong>
          <a>{{ vendorBasicInformation?.vendorOrganizationNameD365 }}</a>
        </h2>
        <a
          style="cursor: pointer"
          [href]="vendorLink"
          target="_blank"
          class="outerlink"
          >{{ vendorLink }}</a
        >
        <a
          aria-controls="collapseExample"
          class="toggle-btn"
          (click)="collapsePanelVendor.toggle($event)"
          [attr.aria-expanded]="!isCollapsed"
          >Need To Make without Content</a
        >
      </div>

      <div>
        <div class="col mb-3 d-flex align-items-center justify-content-between">
          <ul class="nav sidenav">
            <li class="nav-item me-4">
              <a class="nav-link p-0" aria-current="page">YTD Vendor Spend</a>
            </li>
            <li class="nav-item me-4">
              <a class="nav-link p-0">PO by Ship to State</a>
            </li>
          </ul>
          <ul class="nav sidenav ms-auto">
            <li class="nav-item me-4">
              <a
                class="nav-link p-0"
                aria-current="page"
                (click)="openLinesPage()"
                >#Open lines: {{ poLinesCount }}</a
              >
            </li>
            <li class="nav-item me-4">
              <a class="nav-link p-0" (click)="openPoPage()"
                >#Open PO: {{ poHeadersCount }}</a
              >
            </li>
          </ul>
          <a
            (click)="onToggle()"
            [ngClass]="{ active: collapseStatus }"
            class="btn-collapse-all"
            >{{ collapseHeading }} <i class="icon-angle-double ms-2"></i
          ></a>
        </div>
      </div>
    </div>

    <div>
      <div class="status ml-auto me-3">
        All - <span>{{ vendorBasicInformation?.blockedD365 }}</span>
      </div>
      <div class="d-flex align-items-center vendorDetails-date ml-auto">
        <div class="me-2" *ngIf="showLastPODate">
          <span class="me-1 title">Last PO:</span>
          <time>{{
            vendorPOInformation?.lastOrderDate | date: "MM-dd-yyyy"
          }}</time>
        </div>
        <div class="me-2 d-flex align-items-center">
          <span class="me-1" *ngIf="overallScore"
            >Overall Score: {{ overallScore | number: "1.2-2" }}
          </span>
          <span class="me-2" *ngIf="!overallScore"
            >Overall Score: {{ 0.0 }}
          </span>
          <p-rating
            *ngIf="overallScore"
            [(ngModel)]="overallScore"
            stars="5"
            readonly="true"></p-rating>
          <span style="margin-left: 5px; color: #565656">{{
            totalCount | number
          }}</span>
        </div>
      </div>
    </div>
    <div ngbDropdown class="ml-auto ms-4">
      <a
        ngbDropdownToggle
        class="d-flex align-items-center justify-content-center"
      >
        <i class="icon-vertical-dots"></i>
      </a>
      <ul style="display: none" ngbDropdownMenu class="dropdown-menu py-3 mt-1">
        <li><a class="dropdown-item active">Add client</a></li>
        <li><a class="dropdown-item">Client listing</a></li>
        <li><a class="dropdown-item">Client details</a></li>
      </ul>
    </div>
  </header>

  <div class="row"></div>
</div> -->

<!-- Diff -->

<div>
  <div
    class="d-flex justify-content-between align-items-center globalborder-btm-header mb-3 pb-3 pt-2 px-3">
    <div class="d-flex justify-content-between align-items-center gap-3">
      <h2 class="mb-0">Vendor Summary</h2>
      <a
        >Vendor # {{ vendorStatusId }} -
        {{ vendorBasicInformation?.vendorOrganizationNameD365 }}
      </a>
    </div>

    <div class="d-flex align-items-center gap-3">
      <a aria-current="page">YTD Vendor Spend</a>

      <a>PO by Ship to State</a>

      <a aria-current="page" (click)="openLinesPage()"
        >#Open lines: <span class="circle-box">{{ poLinesCount }}</span></a
      >

      <a (click)="openPoPage()"
        >#Open PO: <span class="circle-box">{{ poHeadersCount }}</span>
      </a>

      <!-- <a
        (click)="onToggle()"
        [ngClass]="{ active: collapseStatus }"
        class="btn-collapse-all"
        >{{ collapseHeading }} <i class="icon-angle-double ms-2"></i
      ></a> -->

      <span class="cross-border" (click)="closeVendorModalStacker()"
        ><i class="pi pi-times"></i
      ></span>
    </div>
  </div>

  <div class="row adduser-container-hgt px-3">
    <div class="col-9">
      <div>
        <p-panel
          #collapsePanelVendor
          [toggleable]="true"
          [collapsed]="isCollapsed">
          <ng-template pTemplate="header">
            <span
              ><b>N:</b>
              {{ vendorBasicInformation?.vendorOrganizationNameD365 }}</span
            >
          </ng-template>
          <div class="row">
            <div class="col-3 mb-3">
              <div class="title">Phone:</div>
              <div class="text">
                <!-- {{ vendorBasicInformation?.phoneNumberD365 }} -->
              </div>
            </div>
            <div class="col-3 mb-3">
              <div class="title">Fax:</div>
              <div class="text">
                <!-- {{ vendorBasicInformation?.tax1099FederalTaxIdD365 }} -->
              </div>
            </div>
            <div class="col-3 mb-3">
              <div class="title">Logon:</div>
              <!-- <div class="text">{{ vendorBasicInformation?.logon }}</div> -->
            </div>
            <div class="col-3 mb-3">
              <div class="title">Password:</div>
              <!-- <div class="text">{{ vendorBasicInformation?.password }}</div> -->
            </div>
          </div>
          <div class="row">
            <div class="col-3 mb-3">
              <div class="title">CSR:</div>
              <!-- <div class="text">{{ vendorBasicInformation?.csr }}</div> -->
            </div>
            <div class="col-3 mb-3">
              <div class="title">CSR Phone:</div>
              <!-- <div class="text">{{ vendorBasicInformation?.csrPhone }}</div> -->
            </div>
            <div class="col-6 mb-3">
              <div class="title">CSR Email:</div>
              <!-- <a
              class="email"
              [href]="'mailto:' + vendorBasicInformation?.csrEmail"
              >{{ vendorBasicInformation?.csrEmail }}</a
            > -->
            </div>
          </div>
          <div class="row">
            <div class="col-3 mb-3">
              <div class="title">Order:</div>
              <!-- <a
              class="email"
              [href]="'mailto:' + vendorBasicInformation?.order"
              >{{ vendorBasicInformation?.order }}</a
            > -->
            </div>
            <div class="col-3 mb-3">
              <div class="title">ART:</div>
              <div class="text">
                <!-- <a
                class="email"
                [href]="'mailto:' + vendorBasicInformation?.art"
                >{{ vendorBasicInformation?.art }}</a
              > -->
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-3 mb-3">
              <div class="title mb-1">ASI#:</div>
              <!-- <div class="text">{{ vendorBasicInformation?.asi }}</div> -->
            </div>
            <div class="col-3 mb-3">
              <div class="title">Sage#:</div>
              <!-- <div class="text">{{ vendorBasicInformation?.sage }}</div> -->
            </div>
            <div class="col-3 mb-3">
              <div class="title mb-1">PPAI#:</div>
              <!-- <div class="text">{{ vendorBasicInformation?.ppai }}</div> -->
            </div>
            <div class="col-3 mb-3">
              <div class="title">Acct#:</div>
              <!-- <div class="text">{{ vendorBasicInformation?.acct }}</div> -->
            </div>
          </div>

          <form [formGroup]="vendorSummaryForm">
            <div class="row">
              <div class="col-3">
                <div class="title mb-1">My Rep name:</div>
                <!-- <a>{{ this.businessObject?.name }}</a> -->
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  id="dunsno"
                  class="hideborder"
                  formControlName="name"
                  (focusout)="updateVendorSummaryData()" />
              </div>
              <div class="col-3">
                <div class="title mb-1">Phone:</div>
                <!-- <a
                class="tel"
                target="_blank"
                [href]="this.businessObject?.phoneLink"
                >{{ this.businessObject?.phone }}</a
              > -->
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  id="dunsno"
                  class="hideborder"
                  formControlName="phoneNumber"
                  (focusout)="updateVendorSummaryData()" />
              </div>
              <div class="col-3">
                <div class="title mb-1">Email:</div>
                <!-- <a
                class="email"
                target="_blank"
                [href]="this.businessObject?.emailLink"
                >{{ this.businessObject?.email }}</a
              > -->
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  id="dunsno"
                  class="hideborder"
                  formControlName="emailAddress"
                  (focusout)="updateVendorSummaryData()" />
              </div>

              <div class="col-3" style="overflow-y: scroll">
                <div class="title mb-1">Website:</div>
                <a class="email" target="_blank" [href]="websiteLinkUrl">{{
                  websiteLink
                }}</a>
              </div>
            </div>
          </form>
        </p-panel>
      </div>

      <p-panel [toggleable]="true" [collapsed]="isCollapseOne">
        <ng-template #header>
          <div
            class="d-flex align-items-center justify-content-between pe-5 py-2 position-relative col-8">
            <!-- <a
          class="toggle-btn"
          (click)="isCollapseOne = !isCollapseOne"
          [attr.aria-expanded]="!isCollapseOne"
          >Need To Make without Content</a
        > -->
            <!-- <h2 class="mb-0"> -->
            <!-- Preferred Partner Agreement -->
            <!--- <span class="state">Active</span> -->
            <!-- </h2> -->
            <div class="p-panel-title">
              TAX ID: {{ vendorBasicInformation?.tax1099FederalTaxIdD365 }}
            </div>
            <div class="ml-auto d-flex align-items-center p-panel-title">
              <div class="ms-3 date-time">From: <time>03-02-2021</time></div>
              <div class="ms-3 date-time">To: <time>01-31-2023</time></div>
            </div>
          </div>
        </ng-template>
      </p-panel>
      <p-panel
        [toggleable]="true"
        header="Specials"
        [collapsed]="isCollapseTwo">
        <div
          class="d-flex align-items-center justify-content-between px-3 pe-5 py-2 position-relative">
          <!-- <a
          class="toggle-btn"
          (click)="isCollapseTwo = !isCollapseTwo"
          [attr.aria-expanded]="!isCollapseTwo"
          >Need To Make without Content</a
        > -->
        </div>
      </p-panel>

      <div class="vendorDetails-section mb-3">
        <!-- <header
          class="d-flex align-items-center justify-content-between px-3 pe-5 py-2 position-relative">
          <a
            class="toggle-btn"
            (click)="isCollapseThree = !isCollapseThree"
            [attr.aria-expanded]="!isCollapseThree"
            >Need To Make without Content</a
          >
          <h2 class="mb-0">Vendor Profile</h2>
          <div class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader">
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div class="form-group has-float-label margintop-auto">
            <div class="d-flex text-wrap-cs" style="color: #0085fe">
              <div class="me-3">
                Create
                {{ createdDate | date: "MM-dd-yyyy" }}
                {{ createdDateName }}
              </div>
              <div>
                Mod
                {{ lastModifiedDate | date: "MM-dd-yyyy" }}
                {{ lastModifiedName }}
              </div>
            </div>
          </div>
        </header> -->
        <p-panel
          id="collapseExample3"
          [toggleable]="true"
          [collapsed]="isCollapseThree">
          <ng-template #header>
            <span class="p-panel-title">Vendor Profile</span>

            <div class="d-flex">
              <div class="me-3 p-panel-title">
                Create
                {{ createdDate | date: "MM-dd-yyyy" }}
                {{ createdDateName }}
              </div>
              <div class="p-panel-title">
                Mod
                {{ lastModifiedDate | date: "MM-dd-yyyy" }}
                {{ lastModifiedName }}
              </div>
            </div>
          </ng-template>

          <div class="row">
            <div class="col-3 mb-3">
              <h3>Ethinic Origin:</h3>
              <div class="text">
                {{ vendorBasicInformation?.ethinicOrigin }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col mb-3">
              <div class="form-check d-flex align-items-center gap-2 m-0 p-0">
                <p-checkbox
                  [(ngModel)]="ecoFriendlyStatus"
                  [ngModelOptions]="{ standalone: true }"
                  [binary]="true"
                  id="check1"
                  name="Eco-Friendly Business"
                  (onChange)="venderprofileCheckboxButton($event)" />
                <label class="form-check-label" for="check1">
                  Eco-Friendly Business
                </label>
              </div>
            </div>
            <div class="col mb-3">
              <div class="form-check d-flex align-items-center gap-2 m-0 p-0">
                <p-checkbox
                  [binary]="true"
                  [(ngModel)]="bidOnlyStatus"
                  [ngModelOptions]="{ standalone: true }"
                  id="check2"
                  (onChange)="venderprofileCheckboxButton($event)"
                  name="Bid-Only" />
                <label class="form-check-label" for="check2"> Bid-Only </label>
              </div>
            </div>
            <div class="col mb-3">
              <div class="form-check d-flex align-items-center gap-2 m-0 p-0">
                <p-checkbox
                  [binary]="true"
                  [(ngModel)]="charityFriendly"
                  [ngModelOptions]="{ standalone: true }"
                  id="check3"
                  (onChange)="venderprofileCheckboxButton($event)"
                  name="Charity Friendly" />
                <label class="form-check-label" for="check3">
                  Charity Friendly
                </label>
              </div>
            </div>
            <div class="col mb-3">
              <div class="form-check d-flex align-items-center gap-2 m-0 p-0">
                <p-checkbox
                  [binary]="true"
                  [(ngModel)]="importer"
                  [ngModelOptions]="{ standalone: true }"
                  id="check4"
                  (onChange)="venderprofileCheckboxButton($event)"
                  name="Importer" />
                <label class="form-check-label" for="check4"> Importer </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col mb-3">
              <div class="form-check d-flex align-items-center gap-2 m-0 p-0">
                <p-checkbox
                  [binary]="true"
                  [(ngModel)]="oneTimeSupplier"
                  [ngModelOptions]="{ standalone: true }"
                  id="check5"
                  (onChange)="venderprofileCheckboxButton($event)"
                  name="One Time Supplier" />
                <label class="form-check-label" for="check5">
                  One Time Supplier
                </label>
              </div>
            </div>
            <div class="col mb-3">
              <div class="form-check d-flex align-items-center gap-2 m-0 p-0">
                <p-checkbox
                  [binary]="true"
                  [(ngModel)]="ownerIsAServiceVeteran"
                  [ngModelOptions]="{ standalone: true }"
                  id="check6"
                  (onChange)="venderprofileCheckboxButton($event)"
                  name="Owner is a service veteran" />
                <label class="form-check-label" for="check6">
                  Owner is a service veteran
                </label>
              </div>
            </div>
            <div class="col mb-3">
              <div class="form-check d-flex align-items-center gap-2 m-0 p-0">
                <p-checkbox
                  [binary]="true"
                  [(ngModel)]="smallBusiness"
                  [ngModelOptions]="{ standalone: true }"
                  id="check7"
                  (onChange)="venderprofileCheckboxButton($event)"
                  name="Small Business" />
                <label class="form-check-label" for="check7">
                  Small Business
                </label>
              </div>
            </div>
            <div class="col mb-3">
              <div class="form-check d-flex align-items-center gap-2 m-0 p-0">
                <p-checkbox
                  [binary]="true"
                  [(ngModel)]="ownerIsDisable"
                  [ngModelOptions]="{ standalone: true }"
                  id="check8"
                  (onChange)="venderprofileCheckboxButton($event)"
                  name="Owner is disable" />
                <label class="form-check-label" for="check8">
                  Owner is disable
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col mb-3">
              <div class="form-check d-flex align-items-center gap-2 m-0 p-0">
                <p-checkbox
                  [binary]="true"
                  [(ngModel)]="unionFriendly"
                  [ngModelOptions]="{ standalone: true }"
                  id="check9"
                  (onChange)="venderprofileCheckboxButton($event)"
                  name="Union Friendly" />
                <label class="form-check-label" for="check9">
                  Union Friendly
                </label>
              </div>
            </div>
            <div class="col mb-3">
              <div class="form-check d-flex align-items-center gap-2 m-0 p-0">
                <p-checkbox
                  [binary]="true"
                  [(ngModel)]="promotional"
                  [ngModelOptions]="{ standalone: true }"
                  id="check10"
                  (onChange)="venderprofileCheckboxButton($event)"
                  name="Promotional" />
                <label class="form-check-label" for="check10">
                  Promotional
                </label>
              </div>
            </div>
            <div class="col mb-3">
              <div class="form-check d-flex align-items-center gap-2 m-0 p-0">
                <p-checkbox
                  [binary]="true"
                  [(ngModel)]="bHUBZoneStatus"
                  [ngModelOptions]="{ standalone: true }"
                  id="check11"
                  (onChange)="venderprofileCheckboxButton($event)"
                  name="BHUBZone" />
                <label class="form-check-label" for="check11"> HUBZone </label>
              </div>
            </div>
            <div class="col mb-3">
              <div class="form-check d-flex align-items-center gap-2 m-0 p-0">
                <p-checkbox
                  [binary]="true"
                  [(ngModel)]="madeinUSAStatus"
                  [ngModelOptions]="{ standalone: true }"
                  id="check12"
                  (onChange)="venderprofileCheckboxButton($event)"
                  name="Made in USA" />
                <label class="form-check-label" for="check12">
                  Made In USA
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col mb-3">
              <div class="form-check d-flex align-items-center gap-2 m-0 p-0">
                <p-checkbox
                  [binary]="true"
                  [(ngModel)]="womenOwner"
                  [ngModelOptions]="{ standalone: true }"
                  id="check12"
                  (onChange)="venderprofileCheckboxButton($event)"
                  name="Women Owner" />
                <label class="form-check-label" for="check12">
                  Women Owner
                </label>
              </div>
            </div>
            <div class="col mb-3">
              <div class="form-check d-flex align-items-center gap-2 m-0 p-0">
                <p-checkbox
                  [binary]="true"
                  [(ngModel)]="minorityOwned"
                  [ngModelOptions]="{ standalone: true }"
                  id="check12"
                  (onChange)="venderprofileCheckboxButton($event)"
                  name="Minority Owned" />
                <label class="form-check-label" for="check12">
                  Minority Owned
                </label>
              </div>
            </div>
          </div>
        </p-panel>
      </div>

      <div
        class="gray-bg-rounded vendorDetails-ratings mb-4 d-flex align-items-center justify-content-between">
        <form
          #feedbackForm="ngForm"
          class="ratings-form flex-grow-1"
          (ngSubmit)="feedbackSubmit()">
          <div
            class="d-flex align-items-center justify-content-start mb-3 gap-2">
            <!-- <label class="form-check-label me-2">Vendor Review</label> -->
            <h3 class="mb-0 me-2">Vendor Review</h3>
            <p-rating
              [(ngModel)]="feedbackScore"
              [ngModelOptions]="{ standalone: true }"
              stars="5"
              [readonly]="!isCriteriaSelected"
              (onRate)="feedbackLeave($event)" />

            <ng-container *ngFor="let item of vendorFeedbackArray">
              <div class="d-flex align-items-center gap-2">
                <p-radiobutton
                  [id]="item.name"
                  [name]="item.name"
                  [value]="item.name"
                  (onClick)="criteriaChanged(item.name)"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="feedbackCriteria" />
                <label class="form-check-label" [for]="item.name">{{
                  item.name
                }}</label>
              </div>
            </ng-container>

            <!-- <div class="form-check d-flex align-items-center p-0 ms-2">
            <input
              jniAutoCompleteBlocker
              type="radio"
              class="form-check-input me-2 m-0"
              id="quality"
              name="criteria"
              value="quality"
              (onClick)="criteriaChanged('quality')"
              [(ngModel)]="feedbackCriteria"
            />
            <label class="form-check-label" for="quality">Quality</label>
          </div>
          <div class="form-check d-flex align-items-center p-0 ms-2">
            <input
              jniAutoCompleteBlocker
              type="radio"
              class="form-check-input me-2 m-0"
              id="time"
              name="criteria"
              value="time"
              (onClick)="criteriaChanged('time')"
              [(ngModel)]="feedbackCriteria"
            />
            <label class="form-check-label" for="time">Time</label>
          </div>
          <div class="form-check d-flex align-items-center p-0 ms-2">
            <input
              jniAutoCompleteBlocker
              type="radio"
              class="form-check-input me-2 m-0"
              id="resp"
              name="criteria"
              value="resp"
              (onClick)="criteriaChanged('resp')"
              [(ngModel)]="feedbackCriteria"
            />
            <label class="form-check-label" for="resp">Resp</label>
          </div> -->

            <!-- <p-button
          type="submit"
          class="btn btn-secondary ms-2"
          [disabled]="!isCriteriaSelected" label="Submit"> -->
            <p-button
              type="submit"
              label="Submit"
              [disabled]="!isCriteriaSelected" />

            <!-- <button
              type="submit"
              class="btn btn-secondary ms-2"
              [disabled]="!isCriteriaSelected">
              Submit
            </button> -->
          </div>
          <div class="form-group has-float-label">
            <label
              class="form-label"
              for="notes"
              [hidden]="!currentlySelectedCriteria"
              >Public Vendor Notes</label
            >
            <textarea
              jniAutoCompleteBlocker
              rows="5"
              pTextarea
              name="notes"
              (input)="notesChange($event)"
              [value]="notesvalue"
              [hidden]="!currentlySelectedCriteria"></textarea>
            <!-- <textarea
            style="height: 64px"
            class="form-control"
            name="notes"
            (input)="notesChange('resp', $event)"
            [value]="respNotes"
            [hidden]="!(currentlySelectedCriteria === 'resp')"
          ></textarea>
          <textarea
            style="height: 64px"
            class="form-control"
            name="notes"
            (input)="notesChange('time', $event)"
            [value]="timeNotes"
            [hidden]="!(currentlySelectedCriteria === 'time')"
          ></textarea> -->
          </div>
        </form>
      </div>
    </div>
    <div class="col-3">
      <div
        class="gray-bg-rounded d-flex justify-content-between align-items-center">
        <div class="col-auto">
          <div class="vendorDetails-download d-flex align-items-center">
            <a><i class="pi pi-file-pdf pdf-fontsize"></i></a>
            <div class="d-flex flex-column ms-2">
              <h3 class="d-block mb-0">W9.PDF</h3>
              <a
                [href]="w9AttachmentUrl"
                target="_blank"
                class="d-block text-decoration-none"
                >Download</a
              >
            </div>
          </div>
        </div>
        <div class="col-auto">
          <div class="has-thumb icon">
            <i
              class="pi pi-thumbs-up green-col"
              [ngClass]="{ success: thumbStatus }"></i>
          </div>
        </div>
        <div class="col-auto">
          <p-fileupload
            [hidden]="attachmentFileStatus"
            mode="basic"
            id="file"
            name="file"
            chooseIcon="pi-cloud-upload"
            accept="application/pdf"
            (onUpload)="getVendorW9Upload($event)"
            multiple="false"
            [auto]="true"
            chooseLabel="Upload new File" />
          <!-- <label
            class="vendorDetails-fileupload"
            [hidden]="attachmentFileStatus">
            
            <input
              jniAutoCompleteBlocker
              type="file"
              (change)="getVendorW9Upload($event)"
              id="file"
              accept="application/pdf" />
            Upload new File
          </label> -->
          <div class="ms-1 file" *ngIf="uploadW9AttachmentUrl !== ''">
            <a
              class="file-download"
              (click)="fileDownload(uploadW9AttachmentUrl)"
              ><i class="icon-eye"></i
            ></a>
          </div>
          <span
            class="text-primary small"
            data-toggle="tooltip"
            [title]="w9FileName">
            {{ w9FileName }}
          </span>
          <div class="error" *ngIf="w9FileSize" style="font-size: 0.75rem">
            File must be less than 1 MB
          </div>
        </div>

        <a
          class="file-download"
          *ngIf="uploadW9AttachmentUrl !== ''"
          (click)="fileDownload(uploadW9AttachmentUrl)">
          <i class="pi pi-eye"></i
        ></a>
      </div>

      <div class="gray-bg-rounded mt-3">
        <div class="col-12">
          <div class="ratings p-2 pb-0">
            <div class="row d-flex align-items-center mb-2">
              <div class="title col-6">
                <h3 class="mb-0">
                  Quality: {{ qualityScore | number: "1.2-2" }}
                </h3>
              </div>
              <div class="col-4">
                <p-rating
                  [(ngModel)]="qualityScore"
                  [ngModelOptions]="{ standalone: true }"
                  stars="5"
                  readonly="true"
                  (mouseenter)="opquality.toggle($event)">
                </p-rating>
              </div>
              <div class="col-2 text-center">
                <span class="circle-box">{{ scoreCount | number }}</span>
              </div>
              <p-popover #opquality>
                <jni-vendor-feedback-rating
                  *ngIf="vendorQualityFeedbackObject.length >= 0"
                  [vendorFeedbackObject]="vendorQualityFeedbackObject"
                  [vendorFeedbackHeading]="'Quality review'"
                  (vendorFeedbackEvent)="onDisabledFeedback($event)"
                  [disabledToggle]="importUserRights">
                </jni-vendor-feedback-rating>
              </p-popover>
            </div>
            <div class="row d-flex align-items-center mb-2">
              <div class="title col-6">
                <h3 class="mb-0">On-Time: {{ timeScore | number: "1.2-2" }}</h3>
              </div>
              <div class="col-4">
                <p-rating
                  [(ngModel)]="timeScore"
                  [ngModelOptions]="{ standalone: true }"
                  stars="5"
                  readonly="true"
                  (mouseenter)="optime.toggle($event)">
                </p-rating>
              </div>
              <div class="col-2 text-center">
                <span class="circle-box">{{ timeCount | number }}</span>
              </div>
              <p-popover #optime>
                <jni-vendor-feedback-rating
                  *ngIf="vendorOnTimeFeedbackObject.length >= 0"
                  [vendorFeedbackObject]="vendorOnTimeFeedbackObject"
                  [vendorFeedbackHeading]="'On-Time review'"
                  (vendorFeedbackEvent)="onDisabledFeedback($event)"
                  [disabledToggle]="importUserRights">
                </jni-vendor-feedback-rating>
              </p-popover>
            </div>
            <div class="row d-flex align-items-center mb-2">
              <div class="title col-6">
                <h3 class="mb-0">
                  Responsive: {{ respScore | number: "1.2-2" }}
                </h3>
              </div>
              <div class="col-4">
                <p-rating
                  [(ngModel)]="respScore"
                  [ngModelOptions]="{ standalone: true }"
                  stars="5"
                  readonly="true"
                  (mouseenter)="opresponsive.toggle($event)">
                </p-rating>
              </div>
              <div class="col-2 text-center">
                <span class="circle-box">{{ respCount | number }}</span>
              </div>
              <p-popover #opresponsive>
                <jni-vendor-feedback-rating
                  *ngIf="vendorResponsiveFeedbackObject.length >= 0"
                  [vendorFeedbackObject]="vendorResponsiveFeedbackObject"
                  [vendorFeedbackHeading]="'Responsive review'"
                  (vendorFeedbackEvent)="onDisabledFeedback($event)"
                  [disabledToggle]="importUserRights">
                </jni-vendor-feedback-rating>
              </p-popover>
            </div>
          </div>
        </div>
      </div>

      <div class="gray-bg-rounded mt-3">
        <div
          class="d-flex align-items-center justify-content-between position-relative mb-3">
          <h3 class="mb-0">Contact Information</h3>

          <a
            class="link text-decoration-none cursor-pointer"
            (click)="viewContactInformation()"
            >Manage</a
          >

          <a
            *ngIf="loggedInUserIsAdmin"
            class="link text-decoration-none cursor-pointer d-flex gap-2 align-items-center"
            (click)="addContactInformation()"
            ><i class="pi pi-user-plus"></i>Add New</a
          >

          <!-- <a
            class="toggle-btn"
            (click)="isCollapseFour = !isCollapseFour"
            [attr.aria-expanded]="!isCollapseFour"
            >Need To Make without Content</a
          > -->
        </div>
        <div class="scroll-box-hgt">
          <li
            class="d-flex align-items-center justify-content-between p-2 gap-4 mb-1"
            *ngFor="let item of vendorContacts">
            <div>
              <span class="mb-1" *ngIf="item.purposeD365 === 'Business'">
                Vendor Representative
              </span>
              <span class="mb-0" *ngIf="item.otherSpecification === 'Inside'">
                Inside Representative
              </span>
              <span class="mb-0" *ngIf="item.otherSpecification === 'Website'">
                Website
              </span>
              <div class="d-flex align-items-center mb-1">
                <span class="title mb-0" (click)="onEditContact(item)"
                  >Name:</span
                >
                <span
                  class="text me-1 name mb-0 truncatetext-width2"
                  (click)="onEditContact(item)">
                  {{ item.nameD365 }}
                </span>
                <span
                  class="badge bg-primary name"
                  *ngIf="item?.isPrimaryD365?.toLowerCase() === 'yes'"
                  >Primary</span
                >
              </div>
            </div>
            <div>
              <div class="text d-flex align-items-center">
                <a
                  class="email d-flex gap-2 text-decoration-none truncatetext-width col-10 align-items-center"
                  [href]="item.emailLink"
                  ><i class="pi pi-envelope"></i> {{ item.email }}</a
                >
              </div>
              <div class="text d-flex align-items-center">
                <a
                  class="tel d-flex gap-2 text-decoration-none truncatetext-width col-10 align-items-center"
                  [href]="item.phoneLink"
                  ><i class="pi pi-phone"></i>{{ item.phone }}</a
                >
              </div>
            </div>
          </li>
        </div>
      </div>
      <div class="gray-bg-rounded mt-3">
        <div
          class="d-flex align-items-center justify-content-between position-relative mb-3">
          <h3 class="mb-0">Addresses</h3>

          <a
            class="link text-decoration-none cursor-pointer"
            (click)="ViewAddressInformation()"
            >Manage</a
          >

          <a
            *ngIf="loggedInUserIsAdmin"
            class="link text-decoration-none cursor-pointer d-flex gap-2 align-items-center"
            (click)="addAddressInformation()"
            ><i class="pi pi-user-plus"></i>Add New</a
          >

          <!-- <a
            class="toggle-btn"
            (click)="isCollapseFive = !isCollapseFive"
            [attr.aria-expanded]="!isCollapseFive"
            >Need To Make without Content</a
          > -->
        </div>

        <div
          class="d-flex align-items-center justify-content-end position-relative mb-3">
          <div class="scroll-box-hgt">
            <li
              class="mb-4 d-flex p-2"
              *ngFor="let item of vendorAddressInformation; let i = index">
              <div class="icon">
                <i class="pi pi-map-marker"></i>
              </div>

              <div class="ms-2 w-100">
                <div
                  class="d-flex align-items-center justify-content-between mb-1">
                  <h3 class="mb-0 me-1" *ngIf="item.purposeD365 === '1'">
                    Vendor
                  </h3>
                  <h3 class="mb-0 me-1" *ngIf="item.purposeD365 === '2'">
                    Inside
                  </h3>
                  <h3 class="mb-0 me-1" *ngIf="item.purposeD365 === '5'">
                    Website
                  </h3>
                  <span
                    class="badge bg-primary me-auto"
                    *ngIf="item.isPrimaryD365 === 'YES'"
                    >Primary</span
                  >
                  <span class="tag ml-auto" *ngIf="i === 0">Business</span>
                  <span class="tag ml-auto" *ngIf="i === 1"
                    >Business Delivery</span
                  >
                  <span class="tag ml-auto" *ngIf="i === 2">Delivery</span>
                </div>
                <div class="d-flex">
                  <i class="icon-address me-1"></i>
                  <address class="address mb-0" (click)="onEditAddress(item)">
                    {{
                      item.streetD365 +
                        " " +
                        item.streetNumberD365 +
                        " " +
                        item.cityD365 +
                        ", " +
                        item.stateD365 +
                        ", " +
                        item.zipCodeD365
                    }}
                  </address>
                </div>
              </div>
            </li>
          </div>
        </div>
      </div>

      <div class="gray-bg-rounded mt-3" *ngIf="loggedInUserIsAdmin">
        <div class="col-12">
          <div class="ratings p-2 pb-0">
            <div class="row d-flex align-items-center mb-2">
              <div class="title col-12">
                <h3 class="mb-0">
                  Warehouse:
                  {{ vendorBasicInformation?.warehouse ?? "" }}
                </h3>
              </div>
            </div>

            <div class="row d-flex align-items-center mb-2">
              <div class="title col-12">
                <h3 class="mb-0">
                  Site: {{ vendorBasicInformation?.siteId ?? "" }}
                </h3>
              </div>
            </div>

            <div class="row d-flex align-items-center mb-2">
              <div class="title col-12">
                <h3 class="mb-0">
                  3PL:
                  {{
                    vendorBasicInformation?.threePLD365 === ""
                      ? "No"
                      : vendorBasicInformation?.threePLD365
                  }}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="gray-bg-rounded mt-3">
        <div class="mb-3">
          <h2 class="mb-1">Brands Names</h2>
          <!-- <div class="text">
            Swipewire, Hotlinks, fabwear, tripe, LongFellow, Big Boss
        </div> -->
        </div>
        <div class="mb-3">
          <h2 class="mb-1">Product line</h2>
          <!-- <div class="text">
          Pens, Guitar Stand, Shirts, Drinkware, Smartphones, Branded Fleas,
          Boots, Straws, Disposable caskets
        </div> -->
        </div>
      </div>
    </div>
  </div>
</div>
<jni-modal-stacker
  *ngIf="openPODisplayModal"
  [displayModal]="openPODisplayModal"
  (closeEvent)="closeOpenPOModal()">
  <h1 class="panelHeading">Open PO's</h1>
  <div class="panelBody">
    <jni-vendor-open-po
      [vendorIdFromModal]="vendorStatusId"
      (closeModalOnOpenPOEvent)="closeModalOnOpenPO($event)"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (closeModalEvent)="closeOpenPOModal()">
    </jni-vendor-open-po>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="openLinesDisplayModal"
  [displayModal]="openLinesDisplayModal"
  (closeEvent)="closeOpenLinesModal()">
  <h1 class="panelHeading">Open Line's</h1>
  <div class="panelBody">
    <jni-vendor-open-lines
      [vendorIdFromModal]="vendorStatusId"
      (closeModalOpenLinesEvent)="closeModalOnOpenLines($event)"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (closeModalEvent)="closeOpenLinesModal()">
    </jni-vendor-open-lines>
  </div>
</jni-modal-stacker>
